import {
  OrderStatus,
  OrderType,
  Platform,
  ProductSize,
  ProductType,
} from '../interfaces/Order';

export enum ShipmentStatus {
  PRE_TRANSIT = 'pre_transit',
  IN_TRANSIT = 'in_transit',
  OUT_FOR_DELIVERY = 'out_for_delivery',
  DELIVERED = 'delivered',
  AVAILABLE_FOR_PICKUP = 'available_for_pickup',
  RETURN_TO_SENDER = 'return_to_sender',
  FAILURE = 'failure',
  CANCELLED = 'cancelled',
  ERROR = 'error',
  UNKNOWN = 'unknown',
}

export enum ResendRequestFilter {
  PENDING_RESEND = 'pending_resend',
  RESEND_APPROVED = 'resend_approved',
  RESEND_REJECTED = 'resend_rejected',
}

export enum Country {
  CANADA = 'ca',
  US = 'us',
}

export enum TrackingFilter {
  NoTracking = 'no_tracking',
  TrackingOnly = 'tracking_only',
  ShipmentOnly = 'shipment_only',
  NoTrackingReference = 'no_tracking_reference',
  TrackingReferenceOnly = 'tracking_reference_only',
  NoTrackingCode = 'no_tracking_code',
  TrackingCodeOnly = 'tracking_code_only',
}

export const PRODUCT_TYPE_CHOICE_KEY = 'product_type_choice';

export const OrderStatusColorMap: Record<
  OrderStatus,
  {
    color: string;
    backgroundColor: string;
    borderColor: string;
  }
> = {
  [OrderStatus.PENDING]: {
    color: '#1890ff', // Light blue - waiting/queue state
    backgroundColor: '#e6f7ff',
    borderColor: '#91d5ff',
  },
  [OrderStatus.PRODUCTION_IN_PROGRESS]: {
    color: '#fa8c16', // Orange - active work in progress
    backgroundColor: '#fff7e6',
    borderColor: '#ffd591',
  },
  [OrderStatus.PROCESSED]: {
    color: '#722ed1', // Purple - completed production, ready for shipping
    backgroundColor: '#f9f0ff',
    borderColor: '#d3adf7',
  },
  [OrderStatus.SHIPPING]: {
    color: '#faad14', // Amber - in transit
    backgroundColor: '#fffbe6',
    borderColor: '#ffe58f',
  },
  [OrderStatus.SHIPPED]: {
    color: '#52c41a', // Green - successfully delivered
    backgroundColor: '#f6ffed',
    borderColor: '#b7eb8f',
  },
  [OrderStatus.REFUNDED]: {
    color: '#f5222d', // Red - error/returned state
    backgroundColor: '#fff1f0',
    borderColor: '#ffa39e',
  },
  [OrderStatus.CANCELLED]: {
    color: '#8c8c8c', // Gray - cancelled/inactive state
    backgroundColor: '#f5f5f5',
    borderColor: '#d9d9d9',
  },
};

export const OrderTypeLabelMap: Record<OrderType, string> = {
  [OrderType.HIGH_PRIORITY]: 'Đặc biệt',
  [OrderType.NORMAL]: 'Thường',
};

export const PlatformLabelMap: Record<Platform, string> = {
  [Platform.SHOPEE]: 'Shopee',
  [Platform.TIKTOK]: 'TikTok',
  [Platform.OTHER]: 'Đơn ngoài',
};

export const OrderStatusLabelMap: Record<OrderStatus, string> = {
  [OrderStatus.PENDING]: 'Chờ xử lý',
  [OrderStatus.PRODUCTION_IN_PROGRESS]: 'Đang sản xuất',
  [OrderStatus.PROCESSED]: 'Đã xử lý',
  [OrderStatus.SHIPPING]: 'Đang giao',
  [OrderStatus.SHIPPED]: 'Đã giao',
  [OrderStatus.REFUNDED]: 'Đã hoàn trả',
  [OrderStatus.CANCELLED]: 'Đã hủy',
};

export const TrackingFilterLabelMap: Record<TrackingFilter, string> = {
  [TrackingFilter.NoTracking]: 'Chưa có tracking',
  [TrackingFilter.TrackingOnly]: 'Có tracking',
  [TrackingFilter.ShipmentOnly]: 'Chỉ shipment',
  [TrackingFilter.NoTrackingReference]: 'Chưa có mã vận chuyển',
  [TrackingFilter.TrackingReferenceOnly]: 'Có mã vận chuyển',
  [TrackingFilter.NoTrackingCode]: 'Chưa có tracking code',
  [TrackingFilter.TrackingCodeOnly]: 'Có tracking code',
};

export const ProductSizeMap: Record<ProductSize, string> = {
  [ProductSize.S]: 'S',
  [ProductSize.M]: 'M',
  [ProductSize.L]: 'L',
  [ProductSize.XL]: 'XL',
  [ProductSize.XXL]: '2XL',
  [ProductSize.XXXL]: '3XL',

  [ProductSize.BAG_WITH_LOCK]: 'Túi có khoá',
  [ProductSize.BAG_WITHOUT_LOCK]: 'Túi không khoá',
};

export const ProductSizeTypeMap: Record<ProductSize, ProductType> = {
  [ProductSize.S]: ProductType.TSHIRT,
  [ProductSize.M]: ProductType.TSHIRT,
  [ProductSize.L]: ProductType.TSHIRT,
  [ProductSize.XL]: ProductType.TSHIRT,
  [ProductSize.XXL]: ProductType.TSHIRT,
  [ProductSize.XXXL]: ProductType.TSHIRT,
  [ProductSize.BAG_WITH_LOCK]: ProductType.BAG,
  [ProductSize.BAG_WITHOUT_LOCK]: ProductType.BAG,
};

export const ProductTypeLabelMap: Record<ProductType, string> = {
  [ProductType.TSHIRT]: 'ÁO THUN',
  [ProductType.BAG]: 'TÚI',
};
